import { css } from '@emotion/react';

import Button from 'components/field/Button';

import { faDownload } from '@fortawesome/pro-solid-svg-icons';

const DownloadFile = ({ value }) =>
	value?.includes('http://') ||
	(value?.includes('https://') && (
		<Button
			label={!value ? 'expired' : 'download'}
			variant="blueBorderless"
			icon={faDownload}
			css={css`
				margin: auto;
				gap: 1rem;
				> .typography,
				> .icon {
					font-size: var(--paragraph3-font-size) !important;
				}

				:hover {
					background-color: var(--table-selected-color) !important;
				}
			`}
			onClick={() => {
				window.open(value, '_self');
			}}
			fullWidth
		/>
	));

export default DownloadFile;
